@if (loading()) {
  <div class="resolve-loader">
    <img src="assets/images/loadingIcon.svg" class="loading-icon" />
    Loading...
  </div>
}
